<script lang="ts">
    import type {
        ImportAnalyzeContextReasonType,
        ImportAnalyzeResponseType,
    } from '../../ColumnSelectPro/ColumnSettingsApi';
    import IconPending from '../../../shared/Icons/IconPending.svelte';
    import { ImportApi } from '../ImportApi';
    import { api } from '../../../../stores/api';
    import ButtonSmallBlueRounded from '../../../shared/ButtonSmallBlueRounded.svelte';
    import { onMount } from 'svelte';

    export let analyze: ImportAnalyzeResponseType;
    export let onFinish: () => void;
    export let errors: ImportAnalyzeContextReasonType[] = [];

    let notStartedYet = true;
    let inProgress = false;
    let progressPercent = 0;

    onMount(async () => {
        console.log('ImportAnalyzeResolveLinks mounted');
        notStartedYet = false;
        inProgress = true;
        await resolveLinks();
        inProgress = false;
    });

    async function resolveLinks() {
        errors = [];
        let countLinksToResolve = analyze.needed_to_resolve_from_link.count;
        console.log('Resolving links...', analyze.needed_to_resolve_from_link);
        for (const reason of analyze.needed_to_resolve_from_link.reasons) {
            let link = reason.value[0]; // first element should be the link
            console.log('Resolving link:', link);
            let output = await ImportApi.resolveCoords($api, [link]).catch(err => {
                console.error('Error resolving link:', link, err);
                errors.push(reason);
                errors = errors;
            });
            if (output && (output[0]?.x === null || output[0]?.y === null)) {
                errors.push(reason);
                errors = errors;
            }
            console.log('Resolved coords:', output);
            countLinksToResolve--;
            progressPercent =
                100 - (countLinksToResolve / analyze.needed_to_resolve_from_link.count) * 100;
            if (countLinksToResolve === 0 && errors.length === 0) {
                console.log('All links resolved');
                onFinish();
            }
        }
    }
</script>

{#if analyze.needed_to_resolve_from_link.count > 0}
    {#if notStartedYet}
        <ButtonSmallBlueRounded
            text="Dekoduj"
            on:click={async () => {
                notStartedYet = false;
                inProgress = true;
                await resolveLinks();
                inProgress = false;
            }}
        />
    {:else if inProgress}
        <div style="display: flex; flex-direction: row; align-items: center; column-gap: 6px;">
            <IconPending spin={true} scale={0.7} />
            <div>{progressPercent.toFixed(0)}%</div>
        </div>
    {/if}
{/if}
